var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlutenFree = function SvgGlutenFree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 38 38"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gluten-free_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#gluten-free_svg__b)",
    d: "M19 0C8.525 0 0 8.521 0 19s8.521 19 19 19 19-8.525 19-19S29.475 0 19 0m0 35.966c-4.268 0-8.164-1.597-11.15-4.211l3.623-3.627c.4-.4.4-1.04 0-1.44s-1.04-.399-1.44 0l-3.63 3.635C3.695 27.318 2.033 23.353 2.033 19 2.034 9.646 9.646 2.034 19 2.034c4.353 0 8.314 1.662 11.323 4.368l-3.566 3.57c-.399.4-.399 1.04 0 1.44a1.008 1.008 0 0 0 1.436 0l3.558-3.563c2.614 2.987 4.21 6.879 4.21 11.151 0 9.354-7.61 16.966-16.965 16.966z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gluten-free_svg__c)",
    d: "M15.504 11.888h.01a.69.69 0 0 0 .693-.704V9.852a.69.69 0 0 0-.439-.655.695.695 0 0 0-.777.167.7.7 0 0 0-.194.484v1.349c.022.455.37.69.707.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gluten-free_svg__d)",
    d: "M23.713 22.383a.68.68 0 0 0-.597-.051c-.029.013-.761.287-1.62.784-.729.422-1.332.874-1.8 1.349v-1.581a2.34 2.34 0 0 0 1.907-.004c.707-.31 1.339-.942 1.878-1.877.468-.81.706-1.92.706-3.301 0-.949-.113-1.655-.119-1.69v-2.56a.705.705 0 0 0-1.216-.474.68.68 0 0 0-.19.481v2.1c-.294.13-.675.31-1.162.59-.736.427-1.34.878-1.8 1.35v-.459a2.38 2.38 0 0 0 1.196-.867c.455-.623.688-1.485.688-2.565 0-.95-.342-1.998-1.04-3.208-.367-.638-.71-1.1-.848-1.284V6.777a.702.702 0 1 0-1.403.003v2.343c-.152.203-.481.642-.849 1.28-.687 1.194-1.039 2.272-1.039 3.208 0 1.08.232 1.942.69 2.565.317.429.72.72 1.198.864v.462c-.462-.471-1.065-.923-1.8-1.349-.488-.28-.878-.464-1.162-.593v-2.098a.7.7 0 0 0-.439-.655.695.695 0 0 0-.774.168.69.69 0 0 0-.19.487l.006 2.491s-.13.749-.13 1.755c0 1.378.24 2.488.707 3.298.536.922 1.184 1.574 1.884 1.88.63.272 1.298.278 1.9 0v1.582c-.567-.581-1.26-1.042-1.8-1.349a11.6 11.6 0 0 0-1.613-.78.7.7 0 0 0-.777.19.74.74 0 0 0-.168.351c-.006.033-.132.804-.132 1.794 0 1.378.238 2.485.706 3.294.54.936 1.175 1.569 1.881 1.878a2.33 2.33 0 0 0 1.904.007v1.387a.69.69 0 0 0 .703.694.694.694 0 0 0 .704-.704v-1.38a2.33 2.33 0 0 0 1.903-.007c.707-.31 1.34-.942 1.881-1.881.468-.81.707-1.917.707-3.294 0-.994-.126-1.762-.132-1.794a.7.7 0 0 0-.342-.494zm-5.433 5.405a.9.9 0 0 1-.468.729.9.9 0 0 1-.865.039c-.413-.181-.848-.64-1.226-1.291-.426-.736-.52-1.82-.52-2.594 0-.268.01-.474.02-.642q.26.132.565.303c.932.536 1.658 1.171 1.99 1.746.378.651.555 1.258.504 1.707zm0-6.963c-.036.336-.184.568-.475.733a.89.89 0 0 1-.858.038c-.238-.103-.716-.41-1.226-1.294-.339-.587-.523-1.51-.516-2.594 0-.267.01-.474.02-.638.141.07.316.164.558.3.674.39 1.568 1.006 1.993 1.748.378.652.555 1.259.504 1.707m1.426.003c-.052-.448.129-1.055.503-1.71a3.3 3.3 0 0 1 .587-.723c.388-.367.82-.68 1.404-1.019.248-.142.42-.236.561-.306.01.167.016.37.02.638 0 1.113-.178 2.007-.517 2.594-.377.655-.813 1.117-1.226 1.294a.94.94 0 0 1-.867-.038.92.92 0 0 1-.465-.73m.474-7.214c0 .752-.148 1.368-.416 1.733-.2.267-.442.393-.768.393a.9.9 0 0 1-.771-.393c-.268-.368-.416-.981-.416-1.73 0-.91.532-1.962.848-2.507.149-.248.252-.413.339-.545.09.139.197.303.339.545.316.549.848 1.604.848 2.507zm2.597 11.057c.004.632-.06 1.81-.513 2.594-.506.878-.987 1.187-1.226 1.29a.92.92 0 0 1-.867-.038c-.278-.158-.43-.4-.465-.73-.052-.444.129-1.051.506-1.706q.21-.358.59-.723a7.7 7.7 0 0 1 1.398-1.023c.248-.135.42-.229.565-.303.01.165.019.358.019.639z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gluten-free_svg__e)",
    d: "M22.59 11.888h.01a.693.693 0 0 0 .693-.704v-1.33a.69.69 0 0 0-.436-.654.708.708 0 0 0-.974.652v1.345c.022.455.368.69.706.69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gluten-free_svg__b",
    x1: 9.5,
    x2: 34.833,
    y1: 0,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gluten-free_svg__c",
    x1: 15.149,
    x2: 17.066,
    y1: 9.143,
    y2: 10.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gluten-free_svg__d",
    x1: 16.402,
    x2: 32.918,
    y1: 6.065,
    y2: 16.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gluten-free_svg__e",
    x1: 22.235,
    x2: 24.15,
    y1: 9.146,
    y2: 10.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gluten-free_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h38v38H0z"
  })))));
};
export default SvgGlutenFree;